import Layout from './Layout.vue';
import Widget from './LayoutWidget.vue';

Layout.Widget = Widget;

export default Layout;

export * from './Layout.types';
